<h2 mat-dialog-title>Sharing layer</h2>
@if (data.isNew) {
  <div mat-dialog-content>
    <h3>
      Are you sure you want to share the personal layer <b>{{ this.data.filename }}</b> ?
    </h3>

    <p>Please note:</p>
    <ul>
      <li>
        You are responsible for ensuring GDPR compliance when sharing data that may be considered
        personal (e.g., energy consumption patterns).
      </li>
      <li>
        The platform is not responsible for any GDPR violations resulting from improper data
        sharing.
      </li>
      <li>
        Shared data will be accessible to the specified users, they will be able to see and download
        the data.
      </li>
      <li>You can manage or withdraw the data at any time.</li>
    </ul>

    <p>
      By clicking "Upload and Share" you confirm that you understand your responsibilities and agree
      to comply with GDPR.
    </p>
  </div>

  <div mat-dialog-actions align="end">
    <button matButton="outlined" type="button" class="warn-button" (click)="close()">Cancel</button>
    <button matButton="filled" type="submit" (click)="save()">Upload and Share</button>
  </div>
} @else {
  <div mat-dialog-content>
    <h3>
      Are you sure you want to share the personal layer <b>{{ this.data.filename }}</b> ?
    </h3>

    <p>Please note:</p>
    <ul>
      <li>
        You are responsible for ensuring GDPR compliance when sharing data that may be considered
        personal (e.g., energy consumption patterns).
      </li>
      <li>
        The platform is not responsible for any GDPR violations resulting from improper data
        sharing.
      </li>
      <li>
        Shared data will be accessible to the specified users, they will be able to see and download
        the data.
      </li>
      <li>Removing a user from the list will revoke their access to the layer.</li>

      <li>You can manage or withdraw the data at any time.</li>
    </ul>

    <p>
      By clicking "Update" you confirm that you understand your responsibilities and agree to comply
      with GDPR.
    </p>
  </div>

  <div mat-dialog-actions align="end">
    <button matButton matButton="outlined" type="button" class="warn-button" (click)="close()">
      Cancel
    </button>
    <button matButton="filled" type="submit" (click)="save()">Update</button>
  </div>
}
